import {
  AfterContentInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  ViewChild,
  SimpleChanges,
  EventEmitter,
  AfterViewInit,
} from "@angular/core";

import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map, catchError, retry } from "rxjs/operators";
/**
 * You may include a different variant of BpmnJS:
 *
 * bpmn-viewer  - displays BPMN diagrams without the ability
 *                to navigate them
 * bpmn-modeler - bootstraps a full-fledged BPMN editor
 */
import { importDiagram } from "src/app/shared/services/bpmn-import";
import { throwError } from "rxjs";
import { Viewer } from "src/app/shared/interfaces/bpmn-js";
import { CustomCanvas } from "../../providers/bpmn-props/CustomCanvas";

@Component({
  selector: "app-flowchart-viewer",
  templateUrl: "./flowchart-viewer.component.html",
  styleUrls: ["./flowchart-viewer.component.scss"],
})
export class FlowchartViewerComponent
  implements AfterContentInit, OnChanges, OnDestroy {
  private bpmnJS;
  private eventBus;
  savebtn: string = "";
  emptyDiagram: string = "./assets/bpmn/initial.bpmn";
  emptyXML: string =
    '<?xml version="1.0" encoding="UTF-8"?>' +
    '<bpmn:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" ' +
    'xmlns:bpmn="http://www.omg.org/spec/BPMN/20100524/MODEL" ' +
    'xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" id="Definitions_1" ' +
    'targetNamespace="http://bpmn.io/schema/bpmn"><bpmn:process id="Process_1" isExecutable="false" />' +
    '<bpmndi:BPMNDiagram id="BPMNDiagram_1"><bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_1" />' +
    "</bpmndi:BPMNDiagram></bpmn:definitions>";

  @ViewChild("ref", { static: true }) private el: ElementRef;
  @Output() private importDone: EventEmitter<any> = new EventEmitter();
  @Output() private resizeDone: EventEmitter<any> = new EventEmitter();
  @Input() modal: boolean = false;
  @Input() clear: boolean = false;
  @Input() source: string;
  @Input() openInModal: string;

  constructor(private http: HttpClient) {
    this.bpmnJS = new Viewer({
      additionalModules: [{ canvas: ["type", CustomCanvas] }],
    });
    this.bpmnJS.on("import.done", ({ error }) => {
      if (!error) {
        this.bpmnJS.get("canvas").zoom("fit-viewport");
      }
    });
  }

  ngAfterContentInit(): void {
    this.bpmnJS.attachTo(this.el.nativeElement);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.source) {
      if (!this.source) this.loadUrl(this.emptyDiagram);
      else {
        if (this.isXML(this.source)) {
          this.loadXML(changes.source.currentValue);
        } else {
          this.loadUrl(changes.source.currentValue);
        }
      }
    }
    if (changes.clear) {
      if (this.clear) {
        this.bpmnJS.clear();
        if (this.isXML(this.source)) {
          this.loadXML(this.emptyXML);
        } else {
          this.loadUrl(this.emptyDiagram);
        }
      }
    }
  }
  isXML(source) {
    console.log("isxml", source);
    let parser = new DOMParser();
    const xmlDoc = parser.parseFromString(source, "text/xml");
    return !xmlDoc.querySelector("parsererror");
  }
  ngOnDestroy(): void {
    this.bpmnJS.destroy();
  }

  resize() {
    console.log("resize", !this.modal ? "maximize" : "close");
    this.resizeDone.emit({
      type: !this.modal ? "maximize" : "close",
    });
  }

  loadXML(source: string) {
    console.log("XML===>>>", source);
    const context = this;
    this.bpmnJS.importXML(source, function (err, warnings) {
      console.log(err, warnings);
      if (err) {
        context.importDone.emit({
          type: "error",
          error: err,
        });
      } else {
        context.importDone.emit({
          type: "success",
          warnings,
        });
      }
    });
  }
  /**
   * Load diagram from URL and emit completion event
   */
  loadUrl(url: string) {
    console.log("URL===>>>", url);
    let header = new HttpHeaders({
      Accept: "application/xml",
      "Content-Type": "application/xml",
    });
    return this.http
      .get(url, { headers: header, responseType: "text" })
      .pipe(
        catchError((err) => throwError(err)),
        importDiagram(this.bpmnJS)
      )
      .subscribe(
        (warnings) => {
          this.importDone.emit({
            type: "success",
            warnings,
          });
        },
        (err) => {
          this.importDone.emit({
            type: "error",
            error: err,
          });
        }
      );
  }
}
